import { Link } from "react-router-dom";
import { ArrowLeft, Save, Loader2, ExternalLink } from "lucide-react";
import SaveSuccessIndicator from "./SaveSuccessIndicator";
import ErrorBanner from "./ErrorBanner";

interface EditPageHeaderProps {
  backUrl: string;
  isNew: boolean;
  newTitle: string;
  editTitle: string;
  entityName?: string;
  viewUrl?: string;
  formId: string;
  isSubmitting: boolean;
  isDirty: boolean;
  error?: Error | null;
  isSuccess?: boolean;
  extraActions?: React.ReactNode;
}

export default function EditPageHeader({
  backUrl,
  isNew,
  newTitle,
  editTitle,
  entityName,
  viewUrl,
  formId,
  isSubmitting,
  isDirty,
  error,
  isSuccess,
  extraActions,
}: EditPageHeaderProps) {
  return (
    <>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Link to={backUrl} className="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-gray-700">
            <ArrowLeft className="h-5 w-5 text-gray-600 dark:text-gray-300" />
          </Link>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              {isNew ? newTitle : editTitle}
            </h1>
            {entityName && (
              <p className="mt-1 text-gray-600 dark:text-gray-400">
                {isNew ? `Create a new ${newTitle.toLowerCase()}` : `Editing: ${entityName}`}
              </p>
            )}
          </div>
        </div>

        <div className="flex items-center gap-3">
          {extraActions}
          {isSuccess !== undefined && <SaveSuccessIndicator isSuccess={isSuccess} />}
          {!isNew && viewUrl && (
            <a href={viewUrl} target="_blank" rel="noopener noreferrer" className="btn-secondary">
              <ExternalLink className="h-5 w-5" />
              View
            </a>
          )}
          <button
            type="submit"
            form={formId}
            disabled={isSubmitting || (!isDirty && !isNew)}
            className="btn-primary"
          >
            {isSubmitting ? (
              <>
                <Loader2 className="h-5 w-5 animate-spin" />
                Saving...
              </>
            ) : (
              <>
                <Save className="h-5 w-5" />
                Save
              </>
            )}
          </button>
        </div>
      </div>

      <ErrorBanner error={error} />
    </>
  );
}
